import { render, staticRenderFns } from "./OrderTips.vue?vue&type=template&id=05f09586&scoped=true"
import script from "./OrderTips.vue?vue&type=script&lang=js"
export * from "./OrderTips.vue?vue&type=script&lang=js"
import style0 from "./OrderTips.vue?vue&type=style&index=0&id=05f09586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f09586",
  null
  
)

export default component.exports